import ApiService from '@shared/services/api.service';

const endPoint = '/contact_groups';

const TelegramNotificationService = {
  getTelegramInfo(contactGroupId) {
    return ApiService.get(`${endPoint}/${contactGroupId}/telegram`);
  },

  generateToken(contactGroupId) {
    return ApiService.post(`${endPoint}/${contactGroupId}/telegram/generate`);
  },

  invalidateToken(contactGroupId) {
    return ApiService.delete(`${endPoint}/${contactGroupId}/telegram`);
  },

  getSubscriptions(contactGroupId) {
    return ApiService.get(`${endPoint}/${contactGroupId}/telegram/subscriptions`);
  },

  deleteSubscription(contactGroupId, subscriptionId) {
    return ApiService.delete(`${endPoint}/${contactGroupId}/telegram/subscriptions/${subscriptionId}`);
  },

  updateSeverity(contactGroupId, subscriptionId, triageSeveritySelected) {
    return ApiService.patch(`${endPoint}/${contactGroupId}/telegram/subscriptions/${subscriptionId}/severity`, { 
      triage_severity_selected: triageSeveritySelected 
    }); 
  }
};

export default TelegramNotificationService;
